import { useMemo } from 'react';

import { useSystemConfig, useRouterStatus } from '#/store';

const getPageInfo = (fullPath, menus, ret) => {
  if (!fullPath) return ret;

  const menuItem = menus.find((item) => {
    if (item.fullPath === '/') return false;

    return fullPath.startsWith(`${item.fullPath}/`) || fullPath === item.fullPath;
  });

  if (!menuItem) return ret;

  const newRet = [...ret, menuItem];

  if (!menuItem.subPageSort?.length) return newRet;

  const subMenus = menuItem.subPageSort.map((item) => menuItem.subPage?.[item]);

  return getPageInfo(fullPath, subMenus, newRet);
};

// 处理relatedParentPageId，构造层级信息
const handleRelatedLevel = (pageLevelInfo, menuPageIdMap) => {
  const levelInfo = [...pageLevelInfo];

  const result = [];

  while (levelInfo.length) {
    const last = levelInfo.pop();

    result.push(last);

    if (!last.relatedParentPageId) continue;

    const relatedParent = menuPageIdMap[last.relatedParentPageId];

    if (!relatedParent) continue;

    levelInfo.push(relatedParent);
  }

  return result.reverse();
};

// 菜单路由相关信息
// curPageLevelInfo 当前页面层级信息，从顶层菜单到当前页面的路径
// pageMenuInfo 当前页面每一层菜单的信息
export default function usePageMenuInfo(options) {
  const { category } = options || {};

  const [{ ActiveConfig }] = useRouterStatus();
  const curPath = ActiveConfig?.fullPath || '';

  const [{ allPageConfig, pageId2PageConfig }] = useSystemConfig();

  const { pageMenuInfo, curPageLevelInfo } = useMemo(() => {
    const pageLevelInfo = getPageInfo(curPath, allPageConfig, []);

    const _curPageLevelInfo = handleRelatedLevel(pageLevelInfo, pageId2PageConfig);

    const topMenu = allPageConfig.filter((pageMenu) => {
      const { category: layoutCategory, layout, hideInSidebar } = pageMenu.layout || {};

      return layout && !hideInSidebar && layoutCategory === category;
    });

    // 从第二位开始找子菜单层级
    const _pageMenuInfo = _curPageLevelInfo.reduce((prev, cur, index) => {
      if (index === 0) return [topMenu];

      const parent = _curPageLevelInfo[index - 1];

      const subPageList = (parent.subPageSort || []).map((i) => parent.subPage[i]);

      const showSubPage = subPageList.filter((item) => item.layout && !item.layout.hideInSidebar);

      const relatedParentPageId = cur.relatedParentPageId;

      if (!relatedParentPageId) return [...prev, showSubPage.filter((item) => !item.relatedParentPageId)];

      return [...prev, showSubPage.filter((item) => item.pageId === relatedParentPageId)];
    }, []);

    return {
      pageMenuInfo: _pageMenuInfo,
      curPageLevelInfo: _curPageLevelInfo,
    };
  }, [allPageConfig, category, curPath]);

  return {
    pageMenuInfo,
    curPageLevelInfo,
  };
}
